/**
 * @method getCoverageTypeOrderNumber
 * @param {String} string
 * @return {Number}
 */
import debounce from 'lodash.debounce';

export function getCoverageTypeOrderNumber(CoverageType) {
  if (CoverageType === 'Medical') {
    return 1;
  }
  if (CoverageType === 'Dental') {
    return 2;
  }
  if (CoverageType === 'Vision') {
    return 3;
  }
  if (CoverageType === 'Prescription') {
    return 4;
  }
  return 5;
}

export const getPriceCompareRecentSearchFormattedData = (data) => {
  const formattedData = [];
  if (data?.length > 0) {
    data.map((item, index) => {
      if (
        item?.requestObj &&
        item?.responseObj?.PriceCompareResponse?.length > 0
      ) {
        const itemOBJ = {
          request: {
            requestBy: item?.requestBy,
            serviceForOid:
              item?.requestObj?.searchParams?.procedureForData?.value,
            serviceFor: item?.requestObj?.searchParams?.procedureForData?.label,
            providers:
              item?.requestObj?.searchParams?.providerType === 'facility'
                ? item?.requestObj?.comparison?.selectedCheckedRowData?.map(
                    (data) => formatFacilityName(data?.FacilityName),
                  )
                : item?.requestObj?.comparison?.selectedCheckedRowData?.map(
                    (data) =>
                      formatDoctorName(
                        data?.DoctorTitle,
                        data?.LastName,
                        data?.FirstName,
                        data?.MiddleName,
                        data?.Suffix,
                      ),
                  ),
            requestTitle:
              item?.requestObj?.searchParams?.helthProcedureData?.label,
          },
          delete: false,
          pin: item?.pinned,
          date: Date.parse(item?.requestTime),
          id:
            item?.responseObj?.PriceCompareResponse?.length > 0 &&
            item?.responseObj?.PriceCompareResponse[0]?.RequestId,
        };
        formattedData.push(itemOBJ);
      }
      return;
    });
    return formattedData;
  } else {
    return [];
  }
};

export function formatFacilityName(FacilityName) {
  return `${FacilityName}`;
}

export function findPercentage(min, max) {
  let defaultPercentage = 0;
  if (min > 0) {
    defaultPercentage = (min * 100) / max;
  }
  if (defaultPercentage > 100) {
    defaultPercentage = 100;
  }
  return defaultPercentage;
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}

export function debouncedCall(callback, debounceTime = 500, ...args) {
  const inputArgs = args.join(',');
  debounce(() => callback(inputArgs), debounceTime);
}

export function checkPermission(featureName, permissionFramework) {
  let permissionFwkLen = 0;
  let bPermissionSet = false;

  //permissionFramework = JSON.parse(localStorage.getItem('permissionFramework'));

  permissionFwkLen = permissionFramework?.length || 0;
  for (let idx = 0; idx < permissionFwkLen; idx++) {
    if (
      permissionFramework[idx].level === 'level-0' &&
      permissionFramework[idx].GroupName === featureName &&
      permissionFramework[idx].GroupEnabled === true
    ) {
      bPermissionSet = true;
    }
    if (
      permissionFramework[idx].level === 'level-1' &&
      permissionFramework[idx].PermissionLevel1 === featureName &&
      permissionFramework[idx].PermissionLevel1Enabled === true
    ) {
      bPermissionSet = true;
    }
    if (
      permissionFramework[idx].level === 'level-2' &&
      permissionFramework[idx].PermissionLevel2 === featureName &&
      permissionFramework[idx].PermissionLevel2Enabled === true
    ) {
      bPermissionSet = true;
    }
    if (
      permissionFramework[idx].level === 'level-3' &&
      permissionFramework[idx].PermissionLevel3 === featureName &&
      permissionFramework[idx].PermissionLevel3Enabled === true
    ) {
      bPermissionSet = true;
    }
    if (
      permissionFramework[idx].level === 'level-4' &&
      permissionFramework[idx].PermissionLevel4 === featureName &&
      permissionFramework[idx].PermissionLevel4Enabled === true
    ) {
      bPermissionSet = true;
    }
  }
  return bPermissionSet;
}

export function adminBreadCrumNotShow(location, exceptionCase = false) {
  const hideRoutes = [
    '/admin/user-management', //This can be uncommented later once API is implemented for breadcrum level filter
    '/admin/duplicate-user',
    '/admin/create-new-user',
    '/admin/user-group',
    '/admin/email-reset',
    '/admin/password-reset',
    '/admin/preferences',
    '/admin/create-resource',
    '/admin/edit-resource',
    '/admin/new-contact',
    '/admin/edit-contact',
    '/admin/create-link',
    '/admin/edit-link',
    '/admin/configure-socialmedia',
    '/admin/configure-pages',
    '/admin/security-settings',
    '/admin/create-page',
    '/admin/edit-page',
    '/admin/edit-user',
    '/admin/price-compare/search-results',
    '/admin/price-compare/show-result',
    '/admin/configuration',
    '/admin/view-documents',
    '/admin/upload-document',
    '/admin/Messages-Documents',
    '/admin/create-new-user-new',
    '/admin/security-questions',
    '/admin/report-setting',
    '/admin/help-center',
    '/admin/generate-report',
    '/admin/reports',
    '/admin/my-profile',
    '/admin/manage-claims',
    '/admin/publish-new-message',
    '/admin/price-compare/doctor-details/',
    '/admin/price-compare/facility-details/',
    '/admin/enrollment-life-event',
    '/admin/enrollment-coverage',
    '/admin/enrollment-success',
    '/admin/manage-help-documents',
    `/admin/account-unlock`,
    `/admin/enumeration-audit`,
  ];
  const locationWithoutNumber = location.match(/\d+/g)
    ? location.split(/[0-9]/)[0]
    : location;

  return hideRoutes.includes(locationWithoutNumber) || exceptionCase;
}

export function adminShowReadOnlyBreadCrum(location) {
  const hideRoutes = ['/admin/claim-details', '/admin/view-member'];

  return hideRoutes.includes(location);
}

export function CreateAdminConfig(updatedAppConfigs) {
  return {
    id: 'adminconfig',
    configuration: updatedAppConfigs,
  };
}

export function UpdateNetworkConfig(updatedNetworkConfigs) {
  return {
    id: 'networklist',
    configuration: updatedNetworkConfigs,
  };
}

export function UpdateReportingConfig(updatedConfigs) {
  return {
    id: 'reportconfig',
    configuration: updatedConfigs,
  };
}

/**
 * @method formatDoctorName : format doctor name from given name params
 * @param DoctorTitle : string | null
 * @param LastName : string
 * @param FirstName : string | null
 * @param MiddleName : string | null
 * @param NameSuffix : string | null
 */
export function formatDoctorName(
  DoctorTitle,
  LastName,
  FirstName,
  MiddleName,
  NameSuffix,
) {
  return `${DoctorTitle ? DoctorTitle : ''} ${LastName ? LastName : ''}${
    FirstName ? ', ' + FirstName : ''
  } ${MiddleName ? MiddleName : ''} ${NameSuffix ? NameSuffix : ''}`;
}

/**
 * @method formatMemberName : format user name from given name params
 * @param Title : string | null
 * @param LastName : string
 * @param FirstName : string | null
 * @param MiddleName : string | null
 * @param Suffix : string | null
 */
export function formatMemberName(userInfo) {
  return `${userInfo.Title ? userInfo.Title : ''} ${
    userInfo.LastName ? userInfo.LastName : ''
  }${userInfo.FirstName ? ', ' + userInfo.FirstName : ''} ${
    userInfo.MiddleName ? userInfo.MiddleName : ''
  } ${userInfo.Suffix ? userInfo.Suffix : ''}`;
}
export function formatDependentName(userInfo) {
  return `${userInfo.Title ? userInfo.Title : ''} ${
    userInfo.DepLastName ? userInfo.DepLastName : ''
  }${userInfo.DepFirstName ? ', ' + userInfo.DepFirstName : ''} ${
    userInfo.DepMiddleName ? userInfo.DepMiddleName : ''
  } ${userInfo.DepSuffix ? userInfo.DepSuffix : ''}`;
}

export function apiDataGenerationForCompare({
  selectedCheckedItems,
  searchParamsForUI,
}) {
  const DATA = [];
  const selectedUserOID = searchParamsForUI?.procedureForData.value;
  const selectedMemberType = searchParamsForUI?.procedureForData.memberType;
  let billedAmountVal;
  if (searchParamsForUI?.billedamount === '') {
    billedAmountVal = Number(searchParamsForUI?.billedamount);
  } else {
    billedAmountVal = searchParamsForUI?.billedamount;
  }
  selectedCheckedItems.map((item) => {
    const obj = {
      MemberType: selectedMemberType === 'Member' ? 'Employee' : 'Dependent', //selectedMemberType,
      SelEmployeeMemberOID: selectedUserOID,
      Serviceprovider: item,
      BilledAmt: billedAmountVal,
    };
    if (searchParamsForUI?.helthProcedureData?.codeName) {
      switch (searchParamsForUI?.helthProcedureData?.codeName) {
        case 'CPT4 Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CPTCode';
          break;
        case 'Revenue Codes':
          obj.RevenueCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'Revenue';
          obj.CodeDescription = 'RevenueCode';
          break;
        case 'CDT5 Dental Codes':
          obj.CDT = searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CDT';
          obj.CodeDescription = 'CDTCode';
          break;
        case 'DRG Codes':
          obj.DRGCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'DRGCode';
          obj.CodeDescription = 'DRGCode';
          break;
        case 'HCPCS Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        case 'CPT':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        default:
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = '';
          obj.CodeDescription = '';
          break;
      }
    }
    //obj.CodeOption =  "Revenue";
    //obj.RevenueCode = "0000";
    DATA.push(obj);
    return;
  });
  return DATA;
}

export const getFamilyList = (
  employeeInfo,
  dependentsInfo,
  loggedInMemberType,
  loggedInUserOID,
) => {
  const options = [];
  if (loggedInMemberType === 'Employee') {
    if (dependentsInfo && dependentsInfo.length > 0) {
      options.push({
        label: `Family (${dependentsInfo.length + 1})`,
        value: 'Family',
      });
    }
    options.push({
      label: `${employeeInfo.FirstName} (Employee)`,
      value: employeeInfo.OID,
    });
    dependentsInfo.map((dependent) =>
      options.push({
        label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
        value: dependent.OID,
      }),
    );
  } else {
    dependentsInfo.map((dependent) => {
      if (dependent?.OID === loggedInUserOID) {
        options.push({
          label: `${dependent.FirstName} (${dependent.RelationshipToMember})`,
          value: dependent.OID,
        });
      }
      return;
    });
  }
  return options;
};

export const getDataByClaimID = (ClaimsList) => {
  const listObject = [];
  let list = [];
  if (ClaimsList && ClaimsList.length > 0) {
    list = ClaimsList.map((data) => {
      if (data !== undefined) {
        const requestUrl = data?.config?.url;
        const splitMasterId = requestUrl.split('claimId/')[1];
        const claimId = splitMasterId.split('/')[0];
        const claimDetails = data?.data?.Response?.ReadClaimDTO;
        if (claimDetails) {
          listObject.push({ claimId: claimId, data: claimDetails });
        }
        return list;
      }
      return;
    });
  }
  return listObject;
};

export const frameColumnFor_PC_RecentSearch = () => {
  const columnsList = [
    {
      Header: 'RECENT REQUESTS',
      accessor: 'request',
      Footer: '',
    },
    {
      Header: '',
      accessor: 'delete',
      disableSortBy: true,
      Footer: '',
    },
    {
      Header: '',
      accessor: 'pin',
      disableSortBy: true,
      Footer: '',
    },
    {
      Header: 'DATE',
      accessor: 'date',
      Footer: '',
    },
  ];

  return columnsList;
};

export const showNetworkName = (networkList, item) => {
  let showLabel = '';
  const selectedItem = networkList.filter((f) => f.NetworkName === item);
  showLabel =
    selectedItem && selectedItem.length
      ? selectedItem[0].Portal_Display_Label
      : '';

  return showLabel;
};

export const frameColumnsForDocumentList = () => {
  const columnsList = [
    {
      Header: 'Title',
      accessor: 'Title',
      Footer: '',
    },
    //{
    //Header: 'Document For',
    //accessor: 'senddocumentfor',
    //Footer: '',
    //},
    {
      Header: 'Type',
      accessor: 'Type',
      Footer: '',
    },
    //{
    //Header: 'Reference',
    //accessor: 'ReferenceNumber',
    //Footer: '',
    //},
    {
      Header: 'Sent',
      accessor: 'SentDate',
      Footer: '',
      //Cell: ({value}) => {return moment(value).format('MMM DD YYYY')},
    },
    {
      Header: 'Documents',
      accessor: 'documents',
      Footer: '',
    },
  ];

  return columnsList;
};

export const frameColumnsForAdminDocumentList = () => {
  const columnsList = [
    {
      Header: 'Title',
      accessor: 'Title',
      Footer: '',
    },
    //{
    //Header: 'Document For',
    //accessor: 'senddocumentfor',
    //Footer: '',
    //},
    {
      Header: 'Sent Date',
      accessor: 'SentDate',
      Footer: '',
      //Cell: ({value}) => {return moment(value).format('MMM DD YYYY')},
    },
    {
      Header: 'Sent by',
      accessor: 'Sentby',
      Footer: '',
    },
    {
      Header: 'Document Type',
      accessor: 'Type',
      Footer: '',
    },
    {
      Header: 'Documents',
      accessor: 'documents',
      Footer: '',
    },
  ];

  return columnsList;
};

export const frameColumnsForReportsList = () => {
  const columnsList = [
    {
      Header: 'Report Name',
      accessor: 'reportName',
      Footer: '',
    },
    {
      Header: 'Report Category',
      accessor: 'reportCategory',
      Footer: '',
    },
    {
      Header: 'Generated On',
      accessor: 'createdDate',
      Footer: '',
      //Cell: ({value}) => {return moment(value).format('MMM DD YYYY')},
    },
    {
      Header: 'Status',
      accessor: 'status',
      Footer: '',
    },
    {
      Header: 'Action',
      accessor: 'actions',
      Footer: '',
    },
    //, {
    //Header: 'Type',
    //accessor: 'type',
    //Footer: '',
    //}
  ];

  return columnsList;
};

export const frameColumnsForSearchApproval = () => {
  const columnsList = [
    {
      Header: 'Member',
      accessor: 'FirstName',
      Footer: '',
    },
    {
      Header: 'Client',
      accessor: 'ClientName',
      Footer: '',
    },
    {
      Header: 'Location',
      accessor: 'LocationName',
      Footer: '',
    },
    {
      Header: 'Submitted By',
      accessor: 'createdby',
      Footer: '',
    },
    {
      Header: 'Request Type',
      accessor: 'Subcategory',
      Footer: '',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Footer: '',
    },
    {
      Header: 'Submitted On',
      accessor: 'createddate',
      Footer: '',
      width: 250,
      maxWidth: 250,
      minWidth: 100,
      //sortType: 'basic',
    },
  ];

  return columnsList;
};

export const frameColumnsForProviderApproval = () => {
  const columnsList = [
    //{
    //Header: 'Id',
    //accessor: 'id',
    //Footer: '',
    //},
    {
      Header: 'User',
      accessor: 'user',
      Footer: '',
    },
    {
      Header: 'Affiliations',
      accessor: 'Affiliations',
      Footer: '',
    },
    {
      Header: 'Tax id',
      accessor: 'TaxId',
      Footer: '',
    },
    {
      Header: 'Npi',
      accessor: 'NPI',
      Footer: '',
    },
    //{
    //Header: 'Request Type',
    //accessor: 'requestType',
    //Footer: '',
    //},
    {
      Header: 'Status',
      accessor: 'status',
      Footer: '',
    },
    {
      Header: 'Submitted On',
      accessor: 'SentDate',
      Footer: '',
      sortType: 'basic',
      minWidth: 100,
      maxWidth: 300,
      width: 300,
    },
  ];

  return columnsList;
};
export const frameColumnsForRegistrationApproval = () => {
  const columnsList = [
    {
      Header: 'Member',
      accessor: 'FirstName',
      Footer: '',
      sortingid: 'firstName',
    },
    {
      Header: 'Affiliate Employer',
      accessor: 'ClientName',
      Footer: '',
      sortingid: 'affiliateEmployer',
    },
    {
      Header: 'Email ID',
      accessor: 'Email',
      Footer: '',
      sortingid: 'emailID',
    },
    {
      Header: 'Request Type',
      accessor: 'Subcategory',
      Footer: '',
      sortingid: 'subcategory',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Footer: '',
      sortingid: 'status',
    },
    {
      Header: 'Submitted On',
      accessor: 'createddate',
      Footer: '',
      sortingid: 'createddate',
      width: 250,
      maxWidth: 250,
      minWidth: 100,
      sortType: 'basic',
    },
  ];

  return columnsList;
};

export const frameColumnsForAffilitionsApproval = () => {
  const columnsList = [
    {
      Header: 'Member',
      accessor: 'firstName',
      Footer: '',
      width: 130,
      maxWidth: 130,
      minWidth: 100,
      sortingid: 'firstName',
    },
    {
      Header: 'LastName',
      accessor: 'LastName',
      Footer: '',
    },
    {
      Header: 'Affiliate Employer',
      accessor: 'affiliateemployer',
      Footer: '',
      width: 200,
      maxWidth: 200,
      minWidth: 100,
      sortingid: 'affiliateEmployer',
    },
    {
      Header: 'Email ID',
      accessor: 'userid',
      Footer: '',
      sortingid: 'userid',
    },
    {
      Header: 'Request Type',
      accessor: 'subcategory',
      Footer: '',
      width: 130,
      maxWidth: 130,
      minWidth: 100,
      sortingid: 'subcategory',
    },
    {
      Header: 'Submitted On',
      accessor: 'createddate',
      Footer: '',
      width: 130,
      maxWidth: 130,
      minWidth: 100,
      sortingid: 'createddate',
    },
    {
      Header: 'Status',
      accessor: 'status',
      Footer: '',
      width: 250,
      maxWidth: 250,
      minWidth: 100,
      sortingid: 'status',
    },
    {
      Header: 'OID',
      accessor: 'Oid',
      Footer: '',
    },
  ];

  return columnsList;
};

export const getViewEmployeeDetails = (data, isDependent = false) => {
  const empData = {};
  //empData.Title = data.Title;
  empData.Suffix = data?.Suffix;
  empData.Gender = isDependent ? data.DepGender : data.Gender;
  empData.LastName = isDependent ? data.DepLastName : data.LastName;
  empData.FirstName = isDependent ? data.DepFirstName : data.FirstName;
  empData.BirthDate = data.DateofBirth;
  empData.MiddleName = isDependent ? data.DepMiddleName : data.MiddleName;
  empData.NumberOfDependents = data.NumberofDependents;
  empData.SocialSecurityNumber = isDependent
    ? data.DepSocialSecurityNumber
    : data.SocialsecurityNumber;
  empData.Family = data.Family === 'true' ? true : false;
  empData.AlternateID1 = isDependent
    ? data.AlternativeID1
    : data.AlternativeID1;
  empData.AlternateID2 = isDependent
    ? data.AlternativeID2
    : data.AlternativeID2;
  //empData.LoggedInMemberType = data.LoggedInMemberType;
  empData.MemberID = data.MemberID;
  empData.MemberCertificateNumber = data.MemberCertificateNumber;
  empData.CertificateNumber = isDependent
    ? data.DepCertificateNumber
    : data.Certificatenumber;
  if (data.Age || data.DepAge) {
    empData.Age = isDependent ? data.DepAge : data.Age;
  }
  if (data.MartialStatus) {
    empData.MartialStatus = data.MartialStatus;
  }
  empData.MemberOIDClaims = data.TempID;
  empData.Status = data.Status;
  empData.Race = isDependent ? data.DepRace : data.Race;
  if (isDependent) empData.DepSequenceNumber = data?.DependentSeqNum;
  return empData;
};

export const getViewEmploymentDetails = (data) => {
  const empData = {};
  empData.BlockOfBusinessId = data.BlockofBusinessID;
  //empData.BlockOfBusinessOid = data.BlockOfBusinessOid;
  empData.BlockOfBusinessName = data.BlockofBusinessName;
  empData.ClientId = data.ClientID;
  //empData.ClientOid = data.ClientOid;
  empData.ClientName = data.ClientName;
  empData.Department = data.Department;
  empData.LocationName = data.Location;
  empData.EmploymentStartDate = data.EmploymentStartDate;
  return empData;
};

export const getViewContactInformation = (data, isDependent = false) => {
  const empData = {};
  empData.WorkPhone = data.WorkPhone;
  empData.HomePhone = data.HomePhone;
  empData.MobilePhone = data.MobilePhone;
  empData.Email1 = isDependent ? data.Email1 : data.Email;
  empData.Email2 = data.AlternativeEmail;

  return empData;
};

export const frameColumnsForSearchClaims = () => {
  const columnsList = [
    {
      Header: 'Service Date',
      accessor: 'ServiceDate',
      Footer: '',
      /*sortType: (a, b) => {
        const a1 = new Date(a).getDate();
        const b1 = new Date(b).getDate();
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      },*/
    },
    {
      Header: 'Patient Name',
      accessor: 'PatientName',
      Footer: '',
    },
    {
      Header: 'Claim Type',
      accessor: 'Product',
      Footer: '',
    },
    {
      Header: 'Claim Number',
      accessor: 'Claimnumber',
      sortType: 'basic',
      Footer: '',
    },
    {
      Header: 'Provider',
      accessor: 'ProviderName',
      Footer: '',
    },
    {
      Header: 'Status',
      accessor: 'ClaimStatus',
      Footer: '',
    },
    {
      Header: 'Amount',
      accessor: 'TotalCharge',
      Footer: '',
      sortType: 'basic',
    },
    {
      Header: 'Patient Responsibility',
      accessor: 'PatientResponsibility',
      Footer: '',
      sortType: 'basic',
    },
    {
      Header: 'Plan Pays',
      accessor: 'TotalPaid',
      Footer: '',
      sortType: 'basic',
    },
  ];

  return columnsList;
};
